import hasValidationErrors from '../../components/connectedForm/utils/hasValidationErrors';
import { createBackgroundProcess } from '../../utils/BackgroundJobs';
import SalesOpeningBalancePostMutation from '../../graphql/mutations/salesLedger/SalesOpeningBalancePostMutation.graphql';
import { PostSelectButton } from '../../components/SelectButton';
import getClientMutationId from '../../utils/getClientMutationId';
import { DocumentStatus, ISalesOpeningBalance } from '../../graphql/schema/p4types';

const canBePosted: (openingBalance: ISalesOpeningBalance) => boolean = (openingBalance) => {
  if (openingBalance && openingBalance.documentStatus) {
    return openingBalance.documentStatus === DocumentStatus.Draft;
  }
  return false;
};

const postOpeningBalance: (props: any) => void = (props) => {
  const { values, connectedForm } = props;
  if (hasValidationErrors(connectedForm)) return;
  const input = {
    clientMutationId: getClientMutationId(),
    id: values.id,
  };
  createBackgroundProcess(SalesOpeningBalancePostMutation, input, props, 'back', 'Post Opening Balance', null);
};

export const formActions = [
  {
    description: 'Post Opening Balances',
    component: PostSelectButton,
    fn: postOpeningBalance,
    individualButton: true,
    performSave: true,
    saveMessage: 'Opening balances posted',
    condition: canBePosted,
  },
];
